import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDimension from './dimension.reducer';

export const selectDimensionState = createFeatureSelector<fromDimension.State>(fromDimension.dimensionFeatureKey);

export const selectDimensions = createSelector(selectDimensionState, (state) => state.dimensions);
export const selectIsDimensionsLoading = createSelector(selectDimensionState, (state) => state.isDimensionsLoading);
export const selectIsDimensionsComplete = createSelector(selectDimensionState, (state) => state.isDimensionsComplete);
export const dimensionsError = createSelector(selectDimensionState, (state) => state.dimensionsError);
